export const PRICE_DATA = [
  {
    title: "Head",
    price: "30$",
    additional: "(extra char. +10$)",
  },
  {
    title: "Half body",
    price: "40$",
    additional: "(extra char. +20$)",
  },
  {
    title: "Full body",
    price: "50$",
    additional: "(extra char. +30$)",
  },
];
